import Header from './components/Header';
import MainApp from './containers/MainApp';


function App() {

  return (
    <>
      <Header />
      <MainApp />
    </>
  );
}

export default App;
